<template>
  <component
    :is="tag"
    :class="_column_classes"
    :data-label="responsiveHeadings && columnName ? columnName : null"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatRepeaterTableCol",
  props: {
    id: {
      type: [String, Number]
    },
    align: {
      type: String, // left, right, center
      default: null
    },
    valign: {
      type: String,
      description:
        'Vertical alignment of the column content. The props value is appended to the helper class "valign-" of the table data (td).'
    },
    responsiveHeadings: {
      type: Boolean,
      default: true
    },
    columnName: {
      type: String,
      default: null
    },
    heading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _column_classes: function () {
      var css = {
        "cat-repeater-table-col": true,
        "text-align-right": this.align === "right",
        "text-align-center": this.align === "center",
        "text-align-left": this.align === "left"
      };
      // Vertical alignment is for the td only.
      if (!this.heading && this.valign && this.valign.length > 0) {
        css[`valign-${this.valign}`] = true;
      }
      return css;
    },
    tag: function () {
      return this.heading ? "th" : "td";
    }
  }
});
</script>
